<ion-header class="ion-no-border" [ngClass]="cssClass">
  <ion-toolbar class="ion-no-padding">
    <ion-img slot="start" [alt]="logoAltName" [src]="logo" (click)="goHome()"></ion-img>
    <ion-text class="ion-margin-start">
      <span class="ion-no-margin">
        <ng-content select="[slot=title]"></ng-content>
      </span>
    </ion-text>
    <ion-buttons slot="end">
      <ng-content select="[slot=button]"></ng-content>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
